<template>
  <AulaButtons class="administer-buttons">
    <template v-if="showRepeatingEventOptions">
      <b-dropdown class="dropdown-select text-center" variant="primary" :dropup="dropUp">
        <template #button-content>
          <span class="button-text">
            <Icon :name="iconClassEnum.EDIT_PEN" class="m-0" />
            {{ $getText('CALENDAR_EDIT_EVENT_BUTTON') }}
            <i class="icon icon-Aula_down-arrow" />
          </span>
        </template>
        <b-dropdown-item-btn v-if="showRepeatingOccurrenceOption" @click="emitEditCurrentEvent">
          {{ $getText('CALENDAR_EDIT_REPEATING_OCCURRENCE') }}
        </b-dropdown-item-btn>
        <b-dropdown-item-btn @click="emitEdit">
          {{ $getText('CALENDAR_EDIT_REPEATING_SERIES') }}
        </b-dropdown-item-btn>
      </b-dropdown>
      <b-dropdown class="dropdown-select text-center" variant="primary" :dropup="dropUp">
        <template #button-content>
          <span class="button-text">
            <Icon :name="iconClassEnum.BIN" />
            {{ $getText('DELETE') }}
            <i class="icon icon-Aula_down-arrow" />
          </span>
        </template>
        <b-dropdown-item-btn v-if="showRepeatingOccurrenceOption" @click="emitDeleteCurrentEvent">
          {{ $getText('CALENDAR_EDIT_REPEATING_OCCURRENCE') }}
        </b-dropdown-item-btn>
        <b-dropdown-item-btn @click="emitDelete">
          {{ $getText('CALENDAR_EDIT_REPEATING_SERIES') }}
        </b-dropdown-item-btn>
      </b-dropdown>
    </template>
    <template v-else>
      <AulaButton v-if="showEdit" variant="link" class="text-center" @click="emitEdit">
        <span class="button-text">
          <Icon :name="iconClassEnum.EDIT_PEN" class="m-0" />
          {{ $getText('CALENDAR_EDIT_EVENT_BUTTON') }}
        </span>
      </AulaButton>
      <AulaButton v-if="showDelete" variant="link" class="text-center" @click="emitDelete">
        <span class="button-text">
          <Icon :name="iconClassEnum.BIN" />
          {{ $getText('DELETE') }}
        </span>
      </AulaButton>
    </template>
  </AulaButtons>
</template>
<script>
import { eventResponseStatus } from '../../enums/eventResponseStatus';
import AulaButtons from '../../components/AulaButtons';
import AulaButton from '../../components/AulaButton';
import { mapGetters } from 'vuex';
import { types } from '../../../src/store/types/types';
import Icon from '../../components/Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';

export default {
  components: {
    Icon,
    AulaButton,
    AulaButtons,
  },
  props: {
    showEdit: { type: Boolean, default: false },
    showDelete: { type: Boolean, default: false },
    showRepeatingEventOptions: { type: Boolean, default: false },
    showRepeatingOccurrenceOption: { type: Boolean, default: true },
    dropUp: { type: Boolean, default: false },
  },
  emits: ['editCurrentEvent', 'edit', 'deleteCurrentEvent', 'delete'],
  computed: {
    ...mapGetters({
      isMobile: types.GET_IS_MOBILE,
    }),
    iconClassEnum() {
      return iconClassEnum;
    },
  },
  data() {
    return {
      eventResponseStatus,
    };
  },
  methods: {
    emitEditCurrentEvent() {
      this.$emit('editCurrentEvent');
    },
    emitEdit() {
      this.$emit('edit');
    },
    emitDeleteCurrentEvent() {
      this.$emit('deleteCurrentEvent');
    },
    emitDelete() {
      this.$emit('delete');
    },
  },
};
</script>
<style lang="scss" scoped>
.administer-buttons {
  gap: 16px;
  justify-content: flex-end;
}

.dropdown-select {
  --dropdown-select-padding: 0;
  --dropdown-toggle-padding: 0;

  ::v-deep .dropdown-toggle {
    height: unset;
  }
}
.button-text {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  .aula-icon {
    --font-size: 1.25rem;
  }
}
i.icon-Aula_down-arrow {
  font-size: 6px;
  vertical-align: middle;
}
</style>
